export default __webpack_public_path__ + "static/estimator-dvd-4894de7d48c95c9d8a077c86a31e91dd.svg";